<style lang="less" scoped>
.footerbox {
  width: 100%;
  padding-top: 40px;
}
.footblack {
  background-color: #3f404f;
  width: 100%;
  height: 300px;
  ul {
    padding-top: 70px;
    width: 1200px;
    margin: 0 auto;
    li {
      float: left;
      margin-left: 90px;
      width: 160px;
      color: #999;
      div {
        width: 100%;
        height: 30px;
        span {
          color: #fff;
          height: 30px;
          line-height: 30px;
          display: block;
          float: left;
          min-width: 25px;
          font-size: 20px;
          margin-right: 10px;
        }
      }
      p {
        line-height: 32px;
        a {
          color: #ccc;
          padding-left: 33px;
          &:hover {
            text-decoration: underline;
            color: #f44a07;
          }
        }
      }
      .p1 {
        margin-top: 20px;
      }
      .about {
        background: url(../../assets/xuebitu.png) no-repeat 0 -146px;
      }
      .rewards {
        background: url(../../assets/xuebitu.png) no-repeat -57px -146px;
      }
      .call {
        background: url(../../assets/xuebitu.png) no-repeat -113px -146px;
      }
    }
    .theone {
      margin-left: 0;
      width: 200px;
      img {
        width: 100%;
      }
      p {
        line-height: 32px;
      }
    }
  }
}
.footbuttom {
  width: 100%;
  height: 60px;
  .w1200 {
    width: 1200px;
    height: 60px;
    margin: 0 auto;
    line-height: 60px;
    color: #999;
    font-size: 12px;
    text-align: center;
  }
}
</style>
<template>
  <div class="footerbox">
    <div class="footblack">
      <ul>
        <li class="theone" v-if="appConfig">
          <img :src="appConfig.logo" alt />
          <p>最专业的彩票开奖网站</p>
          <p>数据分析最全面的开奖数据平台</p>
        </li>
        <li>
          <div>
            <span class="about"></span>
            <span class>关于我们</span>
          </div>
          <p class="p1">
            <a href>关于我们</a>
          </p>
          <p>
            <a href>客服中心</a>
          </p>
          <p>
            <a href>商务合作</a>
          </p>
          <p>
            <a href>免责声明</a>
          </p>
        </li>
        <li>
          <div>
            <span class="rewards"></span>
            <span class>中奖神器</span>
          </div>
          <p class="p1">
            <a href>开奖号码</a>
          </p>
          <p>
            <a href>走势图表</a>
          </p>
          <p>
            <a href>玩法规则</a>
          </p>
        </li>
        <li>
          <div>
            <span class="call"></span>
            <span class>免费调用</span>
          </div>
          <p class="p1">
            <a href>自助网址导航</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="footbuttom">
      <div class="w1200">Copyright All rights reserved. kai1168.com 粤ICP备09298233号</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    // 配置
    appConfig(){
      return this.$store.state.service.appConfig;
    },
  }
}
</script>